"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YstRecurringAvailability = exports.YstOnboardingAvailability = exports.TimePeriod = void 0;
const zod_1 = require("zod");
exports.TimePeriod = zod_1.z.enum(['MORNING', 'AFTERNOON', 'EVENING']);
exports.YstOnboardingAvailability = zod_1.z
    .object({
    timezone: zod_1.z.string(),
    entries: zod_1.z.array(zod_1.z.object({
        // html inputs use strings instead of date objects
        date: zod_1.z.coerce.date(),
        periods: zod_1.z.array(exports.TimePeriod).min(1, {
            message: 'You must select at least one time period',
        }),
    })),
})
    .default(() => ({ entries: [], timezone: '' }));
exports.YstRecurringAvailability = zod_1.z
    .object({
    timezone: zod_1.z.string(),
    entries: zod_1.z.array(zod_1.z.object({
        weekday: zod_1.z.number().int().min(0).max(6),
        periods: zod_1.z.array(exports.TimePeriod).min(1, {
            message: 'You must select at least one time period',
        }),
    })),
})
    .default(() => ({ entries: [], timezone: '' }));
//# sourceMappingURL=ystScheduler.js.map